import { StanderedItem } from "./standered.model"


export class CostApprovalResponseModel {
    count: number
    next: string
    previous: string
    results: CostApprovalModel[]
}



export class CostApprovalModel {
    id: number 
    task_details: StanderedItem
    approver_name: string
    created_by_name: string
    status_name: string
    created_at: string
    modified_at: string
    status: number
    comment: string
    created_by: number
    modified_by: number
    task_approval: number 
    approver: number
}